import React from 'react';
import { Hero } from '../components/Hero';
import { PainSection } from '../components/PainSection';
import { TruthSection } from '../components/TruthSection';
import { MethodSection } from '../components/MethodSection';
import { OfferSection } from '../components/OfferSection';
import { ObjectionsSection } from '../components/ObjectionsSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="min-h-screen bg-[#0a1628] text-white selection:bg-[#d4af37] selection:text-[#0a1628]" data-id="element-224">
      <Hero data-id="element-225" />
      <PainSection data-id="element-226" />
      <TruthSection data-id="element-227" />
      <MethodSection data-id="element-228" />
      <OfferSection data-id="element-229" />
      <ObjectionsSection data-id="element-230" />
      <CTASection data-id="element-231" />
      <Footer data-id="element-232" />
    </main>;
}